<template>
  <div style="color: #0D3659;font-size: 14px;">
    <table style="width: 100%;margin: 0 0 30px 0;border-collapse: collapse;">
      <tr>
        <td style="width: 60%;align-content: end;">
          <img src="/assets/images/logos/login-logo.svg" width="150" alt="Company Logo" />
          <div>(888) 572-4020</div>
          <div>
            <strong>Fast-Track Your Payment:</strong>
            <br>
            Please have this invoice signed and email it back to support@tophelpers.com
          </div>
        </td>
        <td style="width: 40%;align-content: end;">
          <div style="width: fit-content;margin-left: auto;">
            <h3 style="margin-bottom: 10px;font-size: 20px;font-weight: 700;">Invoice</h3>
            <div>Date: <strong>{{ delivery.arrival_date }}</strong></div>
            <div>Arrival time: <strong>{{ delivery.arrival_time }}</strong></div>
            <div>Order: <strong>#{{ delivery.id }}</strong></div>
          </div>
        </td>
      </tr>
    </table>

    <hr style="margin-bottom: 10px;display: block;border: 1px solid #8F3985;">

    <div v-if="delivery.acceptor">
      <h3 style="margin: 0;font-size: 20px;font-weight: 700;">{{ delivery.acceptor.name }}</h3>
      <p>{{ delivery.acceptor.address }}</p>
    </div>

    <table style="width: 100%;margin: 20px 0 10px;border-collapse: collapse;">
      <tr>
        <td
          :style="isHomeMove ? 'width: 50%;' : 'width: 33.3333333%;'"
          style="padding-bottom: 15px;align-content: start;"
        >
          <p><strong>Customer info</strong></p>
          <p v-for="(item, index) in customerData" :key="index" v-text="item" style="margin: 0;" />
        </td>
        <td
          :style="isHomeMove ? 'width: 50%;' : 'width: 33.3333333%;'"
          style="padding-bottom: 15px;padding-left: 20px;border-left: 1px solid #0D3659;align-content: start;"
        >
          <p><strong>{{ isHomeMove ? 'Address (In home moving)' : 'Pickup address' }}</strong></p>
          <p v-for="(item, index) in pickupData" :key="index" v-text="item" style="margin: 0;" />
        </td>
        <td
          v-if="!isHomeMove"
          style="width: 33.3333333%;padding-bottom: 15px;padding-left: 20px;border-left: 1px solid #0D3659;align-content: start;"
        >
          <p><strong>Destination address</strong></p>
          <p v-for="(item, index) in destinationData" :key="index" v-text="item" style="margin: 0;" />
        </td>
      </tr>
    </table>

    <h3 style="margin: 0;font-size: 20px;font-weight: 700;">Item List</h3>

    <table style="width: 100%;margin: 20px 0 10px;border: 1px solid #8F3985;border-collapse: collapse;">
      <tr style="background-color: #8F3985;">
        <td style="width: 33.3333333%; border: 1px solid #8F3985; padding: 0 20px 15px 20px; color: #FFF;">
          <strong>Item Name</strong>
        </td>
        <td style="width: 33.3333333%; border: 1px solid #8F3985; padding: 0 20px 15px 20px; color: #FFF;">
          <strong>Weight ({{ totalWeight }})</strong>
        </td>
        <td style="width: 33.3333333%; border: 1px solid #8F3985; padding: 0 20px 15px 20px; color: #FFF;">
          <strong>Quantity</strong>
        </td>
      </tr>
      <tr v-for="({ name, weight, count }, index) in itemsData" :key="index">
        <td style="width: 33.3333333%;border: 1px solid #0D3659;padding: 0 20px 15px 20px;">
          {{ name }}
        </td>
        <td style="width: 33.3333333%;border: 1px solid #0D3659;padding: 0 20px 15px 20px;">
          {{ weight }}
        </td>
        <td style="width: 33.3333333%;border: 1px solid #0D3659;padding: 0 20px 15px 20px;">
          {{ count }}
        </td>
      </tr>
    </table>

    <table style="width: 50%;margin: 10px 0 10px auto;border: 1px solid #0D3659;border-collapse: collapse;">
      <tr v-for="({ name, value }, index) in paymentData" :key="index">
        <td style="width: 60%;border: 1px solid #0D3659;padding: 0 20px 15px 20px;">
          <strong v-if="index === paymentData.length - 1">{{ name }}</strong>
          <template v-else>{{ name }}</template>
        </td>
        <td style="width: 40%;border: 1px solid #0D3659;padding: 0 20px 15px 20px;">
          <strong v-if="index === paymentData.length - 1">{{ value }}</strong>
          <template v-else>{{ value }}</template>
        </td>
      </tr>
    </table>

    <h3 style="margin: 0;font-size: 20px;font-weight: 700;">Signature Section</h3>

    <table style="width: 100%;margin: 20px 0 10px;border: 0;border-collapse: collapse;">
      <tr>
        <td style="width: 33.3333333%;padding: 10px 0 25px 0;">
          <strong>Company Representative</strong>
        </td>
        <td style="width: 33.3333333%;padding: 10px 0 25px 0;">
          _________________________________________
        </td>
      </tr>
      <tr>
        <td style="width: 33.3333333%;padding: 10px 0 25px 0;">
          <strong>Customer Signature</strong>
        </td>
        <td style="width: 33.3333333%;padding: 10px 0 25px 0;">
          _________________________________________
        </td>
      </tr>
    </table>

    <h3 style="margin: 0;font-size: 20px;font-weight: 700;">Service Agreement</h3>
    <p style="margin-top: 10px;"><em>By signing below, you confirm that the delivery services listed in this order were completed as requested and authorize TopHelpers to release payment to the assigned helper or company. You acknowledge that all services were provided satisfactorily and release TopHelpers and the assigned party from any further claims related to this delivery.</em></p>
    <br>
  </div>
</template>

<script>
export default {
  props: {
    delivery: {
      type: Object,
      required: true
    }
  },

  computed: {
    isHomeMove() {
      return this.delivery.is_home_move;
    },

    customerData() {
      return [
        this.delivery.customer.full_name,
        this.delivery.customer.phone,
        this.delivery.customer.email,
        this.delivery.customer.secondary_phone,
      ];
    },

    pickupData() {
      const pickup = this.delivery.pickup ?? null;

      const arr = [
        pickup.address,
        pickup.stairs?.display,
      ];

      if (pickup.contact) {
        arr.push(
          pickup.contact.full_name,
          pickup.contact.phone
        );
      }

      return arr;
    },

    destinationData() {
      const destination = this.delivery.destination ?? null;

      const arr = destination ? [
        destination.address,
        destination.stairs?.display,
      ] : null;

      if (destination && destination.contact) {
        arr.push(
          destination.contact.full_name,
          destination.contact.phone
        );
      }

      return arr;
    },

    itemsData() {
      const items = [];
      this.delivery.items.forEach(item => {
        items.push({
          name: item.name,
          weight: `${ item.weight } lbs`,
          count: item.count,
        });
      });
      return items;
    },

    totalWeight() {
      return this.delivery.items.map(item => item.weight * item.count).reduce((a, b) => a + b) + ' lbs';
    },

    paymentData() {
      const arr = [
        {
          name: 'Base Price',
          value: `$${ this.delivery.original_price }`,
        },
        {
          name: 'Processing Fee',
          value: `$${ this.delivery.system_fee }`,
        }
      ];

      if (this.delivery.tip) {
        arr.push({
          name: 'Tip',
          value: `$${ this.delivery.tip }`,
        });
      }

      arr.push({
        name: 'Total Payout',
        value: `$${ this.delivery.price }`,
      });

      return arr;
    }
  },
}
</script>
